import { render, staticRenderFns } from "./EventSuggestionDialog.vue?vue&type=template&id=53dbf65c"
import script from "./EventSuggestionDialog.js?vue&type=script&lang=js&external"
export * from "./EventSuggestionDialog.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports